import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon, GiftIcon, CheckCircle2Icon, ShieldCheckIcon, DownloadIcon, LockIcon, InfinityIcon, ClockIcon } from 'lucide-react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { bonuses } from './BonusSection';
function BonusPreview() {
  const [expanded, setExpanded] = useState(false);
  return <div className="bg-slate-950/60 border border-amber-500/20 rounded-2xl overflow-hidden mb-8" data-id="element-149">
      <div className="bg-amber-500/10 border-b border-amber-500/20 px-5 sm:px-6 py-4 flex items-center justify-center gap-2 text-amber-500" data-id="element-150">
        <GiftIcon size={18} data-id="element-151" />
        <span className="font-bold text-sm uppercase tracking-widest" data-id="element-152">
          + 5 Bonos Incluidos Gratis Hoy
        </span>
      </div>

      <ul className="divide-y divide-slate-800" data-id="element-153">
        {bonuses.map((bonus, i) => {
        const Icon = bonus.Icon;
        return <li key={i} className="flex items-center gap-3 sm:gap-4 px-5 sm:px-6 py-3.5 text-left" data-id="element-154">
              <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center" data-id="element-155">
                <Icon size={16} className="text-amber-500" data-id="element-156" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-157">
                <div className="text-xs font-bold text-amber-500 uppercase tracking-wider mb-0.5" data-id="element-158">
                  {bonus.number}
                </div>
                <div className="text-sm sm:text-base text-white font-medium leading-snug" data-id="element-159">
                  {bonus.title}
                </div>
              </div>
              <div className="flex flex-col items-end gap-0.5 flex-shrink-0" data-id="element-160">
                <span className="text-xs text-slate-500 line-through" data-id="element-161">
                  {bonus.value}
                </span>
                <span className="text-xs font-bold text-green-400 bg-green-900/30 border border-green-800/50 rounded-full px-2 py-0.5" data-id="element-162">
                  GRATIS
                </span>
              </div>
            </li>;
      })}
      </ul>

      {/* Expanded full content */}
      <AnimatePresence initial={false} data-id="element-163">
        {expanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.4,
        ease: 'easeInOut'
      }} className="overflow-hidden border-t border-slate-800" data-id="element-164">
            <div className="p-5 sm:p-6 space-y-6 text-left bg-slate-950/60" data-id="element-165">
              {bonuses.map((bonus, i) => {
            const Icon = bonus.Icon;
            return <article key={i} className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden" data-id="element-166">
                    <div className="bg-slate-950 p-4 border-b border-slate-800 flex items-center justify-center" data-id="element-167">
                      <img src={bonus.image} alt={bonus.imageAlt} className="w-full max-w-[180px] h-auto object-contain" data-id="element-168" />
                    </div>
                    <div className="p-5" data-id="element-169">
                      <div className="flex items-start gap-3 mb-4 pb-4 border-b border-slate-800" data-id="element-170">
                        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center" data-id="element-171">
                          <Icon size={18} className="text-amber-500" data-id="element-172" />
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-173">
                          <div className="text-xs font-bold tracking-widest text-amber-500 uppercase mb-0.5" data-id="element-174">
                            {bonus.number}
                          </div>
                          <h4 className="text-base sm:text-lg font-bold text-white leading-tight" data-id="element-175">
                            {bonus.title}
                          </h4>
                        </div>
                      </div>
                      <div className="flex flex-wrap items-center gap-2 mb-4" data-id="element-176">
                        <span className="text-xs text-slate-400" data-id="element-177">
                          Valor real:{' '}
                          <span className="text-slate-300 line-through" data-id="element-178">
                            {bonus.value}
                          </span>
                        </span>
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-green-900/30 text-green-400 border border-green-800/50" data-id="element-179">
                          HOY: GRATIS
                        </span>
                      </div>
                      <p className="text-sm sm:text-base font-medium text-white mb-3 leading-relaxed" data-id="element-180">
                        {bonus.intro}
                      </p>
                      <div className="space-y-3 text-sm text-slate-300 leading-relaxed" data-id="element-181">
                        {bonus.body}
                      </div>
                    </div>
                  </article>;
          })}
            </div>
          </motion.div>}
      </AnimatePresence>

      <button type="button" onClick={() => setExpanded(v => !v)} className="w-full flex items-center justify-center gap-2 px-5 py-4 text-sm font-bold text-amber-500 hover:text-amber-400 hover:bg-amber-500/5 transition-colors border-t border-slate-800 uppercase tracking-widest" aria-expanded={expanded} data-id="element-182">
        {expanded ? <>
            Mostrar menos <ChevronUpIcon size={16} data-id="element-183" />
          </> : <>
            Leer más sobre los bonos <ChevronDownIcon size={16} data-id="element-184" />
          </>}
      </button>
    </div>;
}
export const BottomCTASection = () => {
  return <div className="space-y-12 py-8 pb-20" data-id="element-185">
      <FadeIn data-id="element-186">
        <div className="bg-amber-950/30 border border-amber-900/50 rounded-2xl p-6 sm:p-8 text-center" data-id="element-187">
          <h3 className="text-xl font-bold text-amber-500 mb-4 flex items-center justify-center gap-2" data-id="element-188">
            <ClockIcon size={22} data-id="element-189" /> URGENCIA REAL
          </h3>
          <p className="text-lg text-slate-300" data-id="element-190">
            Cada noche que pasa sin el protocolo es una noche más de ácido
            quemando tu esófago. El daño acumulativo del reflujo no tratado no
            espera. Tu esófago tampoco.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-191">
        <div className="bg-slate-900 border border-slate-700 rounded-3xl p-6 sm:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-192">
          <div className="absolute top-0 left-0 w-full h-2 bg-green-500" data-id="element-193"></div>

          <h2 className="text-2xl font-bold text-white mb-8 pt-2" data-id="element-194">
            Tu Inversión:
          </h2>

          {/* Bonus preview list with read more */}
          <BonusPreview data-id="element-195" />

          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-196">
            <div className="text-slate-400 text-xl line-through" data-id="element-197">
              Valor Total: $332 USD
            </div>
            <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white bg-green-900/30 px-5 py-4 rounded-2xl border border-green-800/50 leading-tight" data-id="element-198">
              <span className="text-amber-500 mr-2" data-id="element-199">🔥</span>
              PRECIO DE LANZAMIENTO:{' '}
              <span className="text-green-400" data-id="element-200">$13.99 USD</span>
            </div>
          </div>

          <ul className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-8 text-slate-300 font-medium mb-10" data-id="element-201">
            <li className="flex items-center justify-center gap-2" data-id="element-202">
              <DownloadIcon size={16} className="text-amber-500" data-id="element-203" /> Descarga
              inmediata
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-204">
              <InfinityIcon size={16} className="text-amber-500" data-id="element-205" /> Acceso de
              por vida
            </li>
            <li className="flex items-center justify-center gap-2" data-id="element-206">
              <ShieldCheckIcon size={16} className="text-amber-500" data-id="element-207" /> Garantía
              de 7 noches
            </li>
          </ul>

          <CTAButton text="✅ SÍ, QUIERO MIS 7 NOCHES SIN ARDOR — $13.99 USD →" className="mb-6" data-id="element-208" />

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm text-slate-400 mt-6" data-id="element-209">
            <span className="flex items-center gap-1.5" data-id="element-210">
              <LockIcon size={14} data-id="element-211" /> Pago 100% Seguro
            </span>
            <span className="hidden sm:inline" data-id="element-212">•</span>
            <span className="flex items-center gap-1.5" data-id="element-213">
              <DownloadIcon size={14} data-id="element-214" /> Descarga Inmediata
            </span>
            <span className="hidden sm:inline" data-id="element-215">•</span>
            <span className="flex items-center gap-1.5" data-id="element-216">
              <ShieldCheckIcon size={14} data-id="element-217" /> Garantía Total de 7 Días
            </span>
          </div>
        </div>
      </FadeIn>

      <FadeIn data-id="element-218">
        <div className="pt-8" data-id="element-219">
          <h3 className="text-2xl font-bold text-white text-center mb-8" data-id="element-220">
            Lo que dicen nuestros clientes
          </h3>
          <div className="rounded-2xl overflow-hidden border border-slate-800 shadow-xl" data-id="element-221">
            <img src="https://cdn.magicpatterns.com/uploads/cgzvWDettaMGz4y9D3N6AE/ig_comments_noche_sin_reflujo.png" alt="Comentarios de clientes en Instagram" className="w-full h-auto" data-id="element-222" />
          </div>
        </div>
      </FadeIn>

      <FadeIn data-id="element-223">
        <div className="pt-8" data-id="element-224">
          <CTAButton text="✅ SÍ, QUIERO MIS 7 NOCHES SIN ARDOR — $13.99 USD →" data-id="element-225" />
        </div>
      </FadeIn>
    </div>;
};